import React, { useState, useEffect } from 'react';

import { Layout, Avatar, Menu, Card, Dropdown, Row, Col, Typography, Popover, Spin, Tooltip } from 'antd';
import {
	UserOutlined,
	LogoutOutlined,
} from '@ant-design/icons';

// import {
//     rankItem,
// } from '@tanstack/match-sorter-utils'

// import {
//     flexRender,
//     getCoreRowModel,
//     getFilteredRowModel,
//     useReactTable,
// } from '@tanstack/react-table'


import { errorCatch, GET, JSXMap, QueryDetail, READWITH, ycStorage } from 'fennec-ui';
import useStyles from '../../../common/Styles';

import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from 'fennec-ui';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import { useDispatch, useSelector } from 'react-redux';
import REDUX_AkkauntiPolzovatelei from '../../../objects/AkkauntiPolzovatelei/reducer';
import { MetaContext } from 'fennec-ui';
import Icofont from 'react-icofont';
import REDUX_UserConfig from '../../../objects/UserConfig/reducer'
import REDUX_Translate from '../../../objects/Translate/reducer';
import { getIndexColor, getIndexColorLighter, translate, ycBucket } from '../../../common/Tool';
import YImage from '../../../common/YImage';
import { useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../common/Context';

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

var _ = require('lodash');
const { SubMenu } = Menu;

const { Header, Content, Footer, Sider } = Layout;

const FedHeader = (props) => {
	let navigate = useNavigate();
	const auth = useAuth();
	const dispatch = useDispatch();
	const userConfig = useSelector(REDUX_UserConfig.selector.object) || {};
	const translates = useSelector(REDUX_Translate.selector.object);
	const t = React.useMemo(() => _.bind(translate, {
		translate: translates,
		config: userConfig
	}), [translates, userConfig]);
	// const t = useTranslateContext();
	// console.log(t("да"));

	const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
    const isMobile = useIsMobileContext();
    const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

	const { layout, fullwidth, user, logout, logoutall } = props;
	let lsDiv = (fullwidth || !isDesktopOrLaptop) ? {} : { width: layoutWidth, margin: "0 auto" };
	let lsHeader = (layout === "web") ? { background: "white" } : {};
	let lsFontColor = (layout === "web") ? { color: "rgb(0 0 0 / 65%)" } : { color: "rgba(255, 255, 255, 0.65)" };

	const akkauntiPolzovatelei = useSelector(REDUX_AkkauntiPolzovatelei.selector.array);
	const balance = (akkauntiPolzovatelei) => {
		let v = _.get(akkauntiPolzovatelei, "[0].akkaunt.ostatok")
		if (v) return v;
		return 0;
	};
	const _menu = () => {
		let menu = [];
		menu.push({
			key: 'web',
			label: (<a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/fed/events`} style={{ display: "flex", justifyContent: "space-between" }}>
				<div><i className="fa fa-globe" style={{ paddingRight: "4px", color: "blue" }}></i> {t("Главный сайт")}</div>
			</a>),
		});
		menu.push({
			key: 'lk',
			label: (<a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app`} style={{ display: "flex", justifyContent: "space-between" }}>
				<div><Icofont icon="home" style={{ paddingRight: "8px", color: "orange" }} />{t("Личный кабинет")}</div>
			</a>),
		});
		menu.push({
			key: 'jack',
			label: (<a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch`} style={{ display: "flex", justifyContent: "space-between" }}>
				<div><Icofont icon="ui-calendar" style={{ paddingRight: "4px", color: "green" }} /> {t("Войти в мероприятие")}</div>
			</a>),
		});
		menu.push({
			key: 'profile',
			label: (<a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://auth.${auth.getDomainWithoutSubdomain(window.location.href)}/common/profile`} style={{ display: "flex", justifyContent: "space-between" }}>
				<div><Icofont icon="user" style={{ paddingRight: "4px" }} /> {t("Профиль")}</div>
			</a>),
		});
		menu.push({
			type: 'divider',
		});
		menu.push({
			key: 'logout',
			label: (
				<div style={{ display: "flex", justifyContent: "space-between" }} onClick={logout}>
					<div><LogoutOutlined /> Выход</div>
					<div style={{ flex: 0, color: "red" }} onClick={logoutall}>
						<Tooltip title="Выйти на всех устройствах">
							<Icofont icon="logout" />
						</Tooltip>
					</div>
				</div>
			),
		});
		return menu;
	}
	return (
		<Header className="header" style={{ padding: "0 10px", ...lsHeader }}>
			<div style={lsDiv}>
				<div style={{ float: "left" }}>
					<a href="/fed/events" target="_blank" rel="noreferrer noopener">
						<div className={(layout === "web") ? "logo-blue" : "logo"} />
					</a>
				</div>
				<div style={{ float: "right" }}>
					{user && <div style={{ float: "right" }}>

						<Row style={{ cursor: "pointer" }}>
							<Col style={{ lineHeight: "20px", textAlign: "right" }}>
								<Typography style={{ ...lsFontColor, padding: "12px 15px 0px 0px", fontWeight: "600", fontSize: "13px" }}>
									{user.lastname} {user.firstname}
								</Typography>
								<Typography style={{ ...lsFontColor, padding: "0 15px", fontSize: "12px" }}>
									{/* {user.email} */}
									Баланс:
									<Popover placement="bottom" content={<>
										Счет №{_.get(akkauntiPolzovatelei, "[0].akkaunt.nomerAkkaunta")}
									</>} trigger="click">
										<a href="#" style={{ paddingLeft: "3px", color: (balance(akkauntiPolzovatelei) < 0) ? "red" : "#1890ff" }}>
											{balance(akkauntiPolzovatelei).toLocaleString()} руб.
										</a>
									</Popover>
									{/* <Dropdown overlay={<Menu>
										{JSXMap(akkauntiPolzovatelei, (e,idx)=>
										<Menu.Item key={idx}>
											<div style={{display:"flex",justifyContent:"space-between"}}>
												<div>№{_.get(e, "akkaunt.nomerAkkaunta")}</div>
												<div style={{paddingLeft: "14px"}}>{_.get(e, "akkaunt.ostatok").toLocaleString()} руб.</div>
											</div>
											</Menu.Item>
										)}
										</Menu>}>
											<a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
											{balance(akkauntiPolzovatelei).toLocaleString()} руб.
											</a>
										</Dropdown> */}
								</Typography>
							</Col>
							<Col>
								<Dropdown placement='bottomRight' overlay={
									<div style={{ color: "white", borderRadius: "4px" }}>
										<Menu items={_menu()} />
									</div>}>
									<Avatar src={(user?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + user?.avatarMin : undefined} size="large" shape='square' icon={<UserOutlined style={{ padding: 0 }} />} />
									{/* <Avatar shape="square" size="large" icon={(user.avatarMin) ? <Image
										width={40}
										height={40}
										style={{ background: "transparent" }}
										preview={false}
										src={(user.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + user.avatarMin : "error"}
										fallback="data:image/png;base64,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"
									/> : <UserOutlined style={{ color: "gray" }} />} /> */}
								</Dropdown>
							</Col>
						</Row>

					</div>}

				</div>
			</div>
		</Header>
	);
};
const FedSubheader = (props) => {
	const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
    const isMobile = useIsMobileContext();
    const isDesktopOrLaptop = useIsDesktopOrLaptopContext();
	const { layout, fullwidth } = props;
	let fwHeader = (fullwidth || !isDesktopOrLaptop) ? {} : { width: layoutWidth, padding: "0", margin: "0 auto" };
	let lsHeader = (layout === "web") ? { height: "46px", background: "#f6214b", borderRadius: "2px" } : {};
	let lsDiv = (layout === "web") ? { lineHeight: "46px" } : {};

	return (
		<Header className="subheader" style={{ padding: "0 10px", background: "#fff", ...fwHeader, ...lsHeader }}>
			<div style={{ float: 'right', ...lsDiv }}>
				{/* <DropdownAction menuOptions={{ className: "page-menu" }} trigger={['click']} placement="bottomRight" button={() => (
					<Button style={{ padding: "0 10px", marginRight: "10px", ...lsButton }} type="link">
						<MenuOutlined />
					</Button>)}>
					<MenuItem key="2" onClick={changeFullwidth}>
						<div style={{ minWidth: "200px", display: "flex", justifyContent: "space-between" }}>
							<div style={{ flex: "1" }}>
								{!fullwidth ?
									<><FullscreenOutlined />Во весь экран </> :
									<><FullscreenExitOutlined />Уменьшить </>}
							</div>
						</div>
					</MenuItem>
				</DropdownAction> */}
			</div>
		</Header>
	);
};

function EventResultFinal(props) {
	let navigate = useNavigate();
	let { id } = useParams();
	const auth = useAuth();
	const classes = useStyles();
	const dispatch = useDispatch();
	const { history } = props;

	//-------------------------------------------------------------
	const [layout, setLayout] = useState("web"); // app | web
	const [showContentMenu, setShowContentMenu] = useState(false);
	const [showRightSider, setShowRightSider] = useState(false);
	const [showLeftSider, setShowLeftSider] = useState(false);
	const [showHeader, setShowHeader] = useState(false);
	const [showSubheader, setShowSubheader] = useState(true);
	const [loading, setLoading] = useState(false);
	const [fullwidth, setFullwidth] = useState(false);
	//-------------------------------------------------------------

	const meta = useSelector(state => state.meta);

	const [user, setUser] = useState();
	const [result, setResult] = useState();
	const siteAccess = useSelector(state => state.siteAccess.value);

	const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
    const isMobile = useIsMobileContext();
    const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

	useEffect(() => {
		subscribe();
		return () => {
			unsubscribe();
		};
	}, []);
	const subscribe = () => {
		auth.fetch('/api/meta').then(res => {
			if (res && res.data && dispatch) {
				dispatch({ type: 'META', payload: res.data })
			}
		});
		auth.fetch('/api/iam').then(res => {
			if (res && res.data) {
				setUser(res.data);
			}
		});
		setLoading(true);
		GET(auth, `/api/rezultati-final-dancer/${id}`,
			({ data }) => {
				setResult(data)
				setLoading(false);
			}, (err)=>errorCatch(err, ()=>setLoading(false)));
		RefreshAkkaunti();
		auth.openSocket("/ws/service", "service", function (type, payload) {
			if (type === "reload") {
				window.location.href = window.location.href;
			}
			switch (type) {
				case "siteaccess":
					dispatch({ type: "SITE_ACCESS", payload: payload });
					break;
				case "NeedUpdateAkkauntPolzovatelya":
					RefreshAkkaunti();
					break;
				case "AkkauntiPolzovatelei":
					dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray([payload]));
					break;
				default:
					break;
			}
		});
	};

	const _RefreshAkkaunti = () => {
		READWITH(auth, "AkkauntiPolzovatelei", [
			QueryDetail("model")
		], ({ data }) => {
			if (data) {
				dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray(data));
			}
		}, errorCatch);
	};
	var RefreshAkkaunti = _.throttle(_RefreshAkkaunti, 3000, { 'trailing': false });

	const unsubscribe = () => {
		auth.closeSocket("service");
	};
	const logout = () => {
		auth.logout(() => {
			navigate('/app');
			// history.go(0);
		});
	}
	const logoutall = () => {
		auth.logoutall(() => {
			navigate('/app');
			// history.go(0);
		});
	}
	const style = () => {
		return {
			fullwidth: {
				layout: (fullwidth || !isDesktopOrLaptop) ? {} : { width: layoutWidth, margin: "0 auto" },
				header: (fullwidth || !isDesktopOrLaptop) ? {} : { width: layoutWidth, padding: "0", margin: "0 auto" },
			},
			content: {
				minHeight: 600,
				paddingTob: "0px",
				paddingRight: (!showRightSider) ? "0px" : "10px",
				paddingBottom: "0px",
				paddingLeft: (!showLeftSider) ? "0px" : "10px",
				// background: "white"
			}
		}
	};
	const changeFullwidth = () => {
		setFullwidth(!fullwidth ? true : false);
	};

	return (
		<MetaContext.Provider value={meta}>
			{(!siteAccess || siteAccess == "allow") && <Layout>
				<FedHeader user={user} logout={logout} logoutall={logoutall} layout={layout} fullwidth={fullwidth} />
				{showSubheader && <FedSubheader layout={layout} fullwidth={fullwidth} changeFullwidth={changeFullwidth} />}
				<Content style={{ padding: '10px 10px 0 10px' }}>
					<Layout style={style().fullwidth.layout}>
						{showLeftSider && <Sider theme="light"></Sider>}
						<Content style={{ ...style().content }}>
							<div style={{ display: "flex", justifyContent: "space-between" }}>
								<div style={{ flex: "1 1 auto", overflow: "hidden" }}>
									{showHeader && <Row gutter={[5, 5]}>
										<Col span={24}>
											<Card size="small" bordered={false} className={classes.block}>Header</Card>
										</Col>
									</Row>}
									<Row gutter={[5, 5]}>
										<Col span={24}>
											<Card size="small" bordered={false} className={classes.block}>
												<Spin spinning={loading}>
													<div style={{ height: "100%", backgroundColor: "white", padding: "0 15px", borderRadius: "4px" }}>
														{result?.meropriyatie && <div style={{ textAlign: "center", padding: "15px" }}>
															{/* <div style={{ fontSize: "16px", fontWeight: "100" }}>Ваши результаты для участия в мероприятии</div> */}
															<div style={{ fontSize: "22px", fontWeight: "600", lineHeight: "22px" }}>
																<a href={`/fed/event/${id}`}>{result?.meropriyatie?.nazvanieMeropriyatiya}</a>
															</div>
															<div style={{ fontSize: "18px", fontWeight: "600", lineHeight: "30px" }}>г. {result?.meropriyatie?.mestoProvedeniya?.name}</div>
														</div>}
														{result?.meropriyatie && <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "15px", paddingBottom: "25px" }}>
															<div style={{ flex: "0 0 250px", maxWidth: "250px" }}>
																<div style={{ width: "250px", height: "250px", overflow: "hidden", borderRadius: "6px" }}>
																	<YImage item={result?.meropriyatie} width={250} />
																</div>
																<div style={{ marginTop: "7px" }}>
																	<div style={{
																		backgroundColor: "#eaeaea",
																		fontSize: "16px",
																		fontWeight: "400",
																		color: "black",
																		borderRadius: "6px",
																		textAlign: "center",
																		padding: "0 7px",
																		textAlign: "center",
																	}}>
																		<div style={{
																			borderRadius: "5px",
																			backgroundColor: "#f6214b",
																			fontSize: "12px",
																			fontWeight: "600",
																			color: "white",
																			margin: "0 -7px",
																			boxShadow: "0px 6px 5px -5px rgb(34 60 80 / 60%",
																			padding: "3px 7px"
																		}}>
																			{dayjs(result?.meropriyatie?.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}
																		</div>
																		<div style={{
																			fontSize: "10px",
																			fontWeight: "400",
																			padding: "0px"
																		}}>
																			{dayjs(result?.meropriyatie?.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
																		</div>
																	</div>
																</div>
															</div>
															{result && <div style={{ width: "100%" }}>
																<div>🕺💃🕺💃🕺💃🕺💃</div>
																<div>✅ В сезоне {result?.meropriyatie?.sezonDlyaFinala} года Вы участвовали в соревнованиях Федерации – отборах на {result?.meropriyatie?.nazvanieMeropriyatiya}, 
																	который состоится {dayjs(result?.meropriyatie?.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD MMMM')} в г. {result?.meropriyatie?.mestoProvedeniya?.name}.</div>

																{(result?.dancerMeropriyatiya?.length > 0) && <div style={{ marginTop: "15px" }}>
																	<div>💥 Вы участвовали в следующих соревнованиях Сезона {result?.meropriyatie?.sezonDlyaFinala}:</div>
																	{JSXMap(result?.dancerMeropriyatiya, (item, idx) => (
																		<div key={idx}>
																			<span>👉 {dayjs(item?.step.rezultatTantsoraVSerii.meropriyatieVSerii.meropriyatie.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}, </span>
																			<span>{item?.step.rezultatTantsoraVSerii.meropriyatieVSerii.meropriyatie.mestoProvedeniya.name}, </span>
																			<span>{item?.step.rezultatTantsoraVSerii.meropriyatieVSerii.meropriyatie.nazvanieMeropriyatiya}, </span>
																			<span>категория </span>
																			<span>{item?.dancer.kategoriyaUchastnikovSerii.kategoriyaUchastnikov.nazvanie} - </span>
																			<span>{item?.dancer.kategoriyaUchastnikovSerii.tantsevalnayaDistsiplina.nazvanie}, </span>
																			<span>место {item?.step.rezultatTantsoraVSerii.place}.</span>
																		</div>
																	))}
																</div>}

																{(result?.dancerSerii?.length > 0) && <div style={{ marginTop: "15px" }}>
																	<div>🕺💃🕺💃🕺💃🕺💃</div>
																	<div>✅ Соревнования, в которых Вы принимали участие, входили в следующие Серии:</div>
																	{JSXMap(result?.dancerSerii, (item, idx) => {
																		let kvota = 0;
																		if (item?.dancer?.kategoriyaUchastnikovSerii?.kvotiKategoriya?.length > 0) {
																			kvota = item.dancer.kategoriyaUchastnikovSerii.kvotiKategoriya[0].kvotaPartneri
																			if (item.dancer.uchastnik.genderID == 2) {
																				kvota = item.dancer.kategoriyaUchastnikovSerii.kvotiKategoriya[0].kvotaPartnershi
																			}
																		}
																		return (<div key={idx}>
																			<span>👉 Серия: </span>
																			<span>{item.dancer.kategoriyaUchastnikovSerii.seriya.nazvanie} </span>
																			<span>(квота на {result?.meropriyatie?.nazvanieMeropriyatiya}: {kvota}), </span>
																			<span>Категория </span>
																			<span>{item.dancer.kategoriyaUchastnikovSerii.kategoriyaUchastnikov.nazvanie} - </span>
																			<span>{item.dancer.kategoriyaUchastnikovSerii.tantsevalnayaDistsiplina.nazvanie}, </span>
																			<span>Ваше итоговое место: </span>
																			<span>{item.dancer.place}.</span>
																		</div>
																		)
																	})}
																</div>}

																{(result?.rezultatiMeropriyatiyaDlyaFinala?.length > 0) && <div style={{ marginTop: "15px" }}>
																	<div>🕺💃🕺💃🕺💃🕺💃</div>
																	<div>✅ По результатам Сезона {result?.meropriyatie?.sezonDlyaFinala} Вы вошли в квоту на {result?.meropriyatie?.nazvanieMeropriyatiya} в следующих категориях:</div>
																	{JSXMap(result?.rezultatiMeropriyatiyaDlyaFinala, (item, idx) => (<div key={idx}>
																		<span>👉 Категория </span>
																		<span>{item.kategoriyaUchastnikovSerii.kategoriyaUchastnikov.nazvanie} - </span>
																		<span>{item.kategoriyaUchastnikovSerii.tantsevalnayaDistsiplina.nazvanie} </span>
																		<span>(из Серии {item.kategoriyaUchastnikovSerii.seriya.nazvanie}). </span>
																		<span>Баллы в зачет {result?.meropriyatie?.nazvanieDlyaFinalaRp}: </span>
																		<span>💥{item.pointsByTemplate}💥.</span>
																	</div>
																	))}
																</div>}
																<div style={{ marginTop: "15px" }}>🕺💃🕺💃🕺💃🕺💃</div>
																<div>От всей души поздравляем Вас!!</div>
																<div>🕺💃🕺💃🕺💃🕺💃</div>

																{(result?.marketDancer?.length > 0) && <div style={{ marginTop: "15px" }}>
																	{JSXMap(result?.marketDancer, (item, idx) => (<div key={idx}>
																		{(item.length > 1) && <div>
																			<span>✅ В категории </span>
																			<span>{item[0].kategoriyaUchastnikovSerii.kategoriyaUchastnikov.nazvanie} - </span>
																			<span>{item[0].kategoriyaUchastnikovSerii.tantsevalnayaDistsiplina.nazvanie} </span>
																			<span>Вы вошли в квоту по нескольким Сериям, в итоге Федерация дала Вам квоту из той Серии, из которой Вы придете на {result?.meropriyatie?.nazvanieMeropriyatiya} с бОльшим количеством очков. Ваше место в оставшихся Сериях Федерация отдала следующему по рейтингу этой Серии участнику.</span>
																		</div>}
																	</div>
																	))}
																</div>}

																{(result?.isOutKvotaPlace) && <div style={{ marginTop: "15px" }}>
																	✅ В некоторых Сериях Ваше итоговое место оказалось ниже, чем квота, но Вы все равно вошли в квоту. Это произошло из-за того, что некоторые участники, что были выше Вас, получили квоту от других Серий, и Вам Федерация предоставила их место в этой Серии.
																</div>}

																<div style={{ marginTop: "15px" }}>🕺💃🕺💃🕺💃🕺💃</div>
																<div>Подтвердите, пожалуйста, свое участие в {result?.meropriyatie?.nazvanieDlyaFinalaPp}.</div>

																{(result?.rezultatiMeropriyatiyaDlyaFinala?.length > 1) && <div style={{ marginTop: "15px" }}>
																	✅ Вы получили квоту в нескольких категориях, но участвовать можно ТОЛЬКО В ОДНОЙ КАТЕГОРИИ, поэтому выберите категорию, в которой будете участвовать на {result?.meropriyatie?.nazvanieDlyaFinalaPp}. Мы рекомендуем выбрать более высокую категорию, так как чем выше категория, тем больше престиж.
																</div>}

																<div style={{ marginTop: "15px" }}>👉 Если не сможете принять участие, просьба все равно дать обратную связь.</div>
																<div style={{ marginTop: "15px" }}>🕺💃🕺💃🕺💃🕺💃</div>
																<div style={{ marginTop: "15px" }}>Регистрация на {result?.meropriyatie?.nazvanieMeropriyatiya} доступна по ссылке <a target="_blank" href={`https://social-dance.club/fed/event/${result?.meropriyatie?.ID}`}>https://social-dance.club/fed/event/{result?.meropriyatie?.ID}</a>.</div>
																<div style={{ marginTop: "15px" }}>💥 На {result?.meropriyatie?.nazvanieDlyaFinalaPp} будет также награждение по общим зачетам всех Серий Сезона!!</div>
																<div style={{ marginTop: "15px" }}>🕺💃🕺💃🕺💃🕺💃</div>
																<div>Обратная связь в телеграме: Владимир Штотланд (89859241061).</div>
																<div>Обратная связь в ВК – в чате с Федерацией, либо с <a target="_blank" rel="noopener noreferrer" href="https://vk.com/id2304069">Владимиром Штотландом</a></div>
															</div>}
														</div>}
													</div>
												</Spin>
											</Card>
										</Col>
									</Row>
								</div>
							</div>
						</Content>
						{showRightSider && <Sider width={185} theme={"light"}></Sider>}
					</Layout>
				</Content>
				<Footer style={{ textAlign: 'center' }}>
					Общероссийская физкультурно-спортивная общественная организация "Всероссийская федерация социальных танцев"
				</Footer>
			</Layout >}
		</MetaContext.Provider >
	);
};

export default React.memo(EventResultFinal);
// Payment.whyDidYouRender = true